import styled from 'styled-components';
import COLORS from '../../constants/colors';

export const ToggleContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999999;
`;

export const ToggleBackground = styled.div`
  position: relative;
  display: inline-flex;
  width: auto;
  padding: 2px;
  border-radius: 34px;
  z-index: 0;
  border: 1px solid ${COLORS.GREY_BORDER_HEADER};

  &::after {
    border-radius: 34px;
    position: absolute;
    content: "";
    display: block;
    inset: 0px 0% 0px 0px;
    z-index: -2;
    background-color: rgb(245, 246, 247);
  }

  button {
    -webkit-box-align: center;
    align-items: center;
    appearance: none;
    background: none;
    border-radius: 34px;
    border: none;
    color: rgb(27, 36, 55);
    cursor: pointer;
    display: flex;
    -webkit-box-flex: 1;
    flex-grow: 1;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0px;
    overflow: hidden;
    text-align: center;
    transition: color 0.15s ease-in-out 0s, background 0.15s ease-in-out 0s;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    z-index: 1;
    padding: 4px 18px;
    min-height: 32px;
    font-family: "HCo Gotham Narrow", -apple-system, BlinkMacSystemFont, helvetica, arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;

    &[aria-checked="true"] {
      color: rgb(17, 71, 179);
      cursor: default;
    }

    &:hover, &[aria-checked="true"]:hover {
      color: #2e77d0;
    }

    span {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
    }
  }
`;

export const Indicator = styled.div`
  left: ${props => (props.activeIsPublished ? '69.9652px;' : '1.99652px;')}
  width: ${props => (props.activeIsPublished ? '98.4722px;' : '67.9688px;')};
  top: 1.99653px;
  height: 31.9965px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 4px;
  border-radius: 34px;
  padding: 0px 12px;
  pointer-events: none;
  position: absolute;
  transition: left 200ms cubic-bezier(0.345, -0.135, 0, 1) 0s, width 200ms cubic-bezier(0.345, -0.135, 0, 1) 0s;
  z-index: -1;
`;